module.exports = __webpack_public_path__ + "7851ce01f4fb72b6a6cfa7f9d909fb40.png";